<app-widget [widget-meta]="this.data"
  class="widget-contacts">
  <!--<div *ngIf="contacts.data$ | async as contacts; else loadingOrError.template">
  <ul *ngIf="!!contacts && contacts.length > 0" class="contact-list">
    <li *ngFor="let contact of contacts" class="contact-list-item">
      <h5>{{contact.Title}}</h5>
      <small *ngIf="!!contact.JobTitle">{{contact.JobTitle}}<br></small>
      <small *ngIf="!!contact.Group">{{contact.Group}}<br></small>
      <small *ngIf="!!contact.Phone">{{contact.Phone}}<br></small>
      <small *ngIf="!!contact.Email"><a href="mailto:{{contact.Email}}">{{contact.Email}}</a></small>
    </li>
  </ul>
  <ng-container *ngIf="!!!contacts || contacts.length === 0">
    <div class="row">
      <div class="col-md-12">
        <p>Darn! We couldn't find any contacts for you. If you think this is not correct reach out to the IT Service Desk at <a href="mailto:itservicedesk@kenan-flagler.unc.edu">itservicedesk@kenan-flagler.unc.edu</a>.</p>
      </div>
    </div>
  </ng-container>
</div>-->


@if (contacts.data$ | async; as contacts) {
  <div>
    @if (!!contacts && contacts.length > 0) {
      <div class="row m-2 contacts-container">
        @for (contact of contacts; track contact) {
          <div class="col-6">
            <div class="row m-2">
              <div class="col-sm-2">
                @if (contact.Image == '' || contact.Image == null) {
                  <div>
                    <i class="{{contact.Icon}} contact-no-image"></i>
                  </div>
                }
                @else {
                  <div class="contact-image">
                    <img src="{{contact.Image}}" alt="{{contact.Title}} photo"/>
                  </div>
                }
              </div>
              <div class="col-sm-10">
                <h5>{{contact.Title}}</h5>
                @if (!!contact.JobTitle) {
                  <div>{{contact.JobTitle}}</div>
                }
                @if (!!contact.Group) {
                  <div>{{contact.Group}}</div>
                }
                @if (!!contact.Phone) {
                  <div>{{contact.Phone}}</div>
                }
                @if (!!contact.Email) {
                  <div><a style="overflow-wrap:break-word;" href="mailto:{{contact.Email}}">{{contact.Email}}</a></div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (!!!contacts || contacts.length === 0) {
      <div class="row">
        <div class="col-md-12">
          <p>Darn! We couldn't find any contacts for you. If you think this is not correct reach out to the IT Service Desk at <a href="mailto:itservicedesk@kenan-flagler.unc.edu">itservicedesk&#64;kenan-flagler.unc.edu</a>.</p>
        </div>
      </div>
    }
  </div>
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}



<loading-or-error #loadingOrError
  [loadingWrapper]="contacts"
  [errorMessage]="'Oops! Looks like we can\'t get information for Contacts!'">
</loading-or-error>

</app-widget>
